export const UPDATE_SALE = 'UPDATE_SALE';

export const START_SALE_REQUEST = 'START_SALE_REQUEST';
export const START_SALE_FAILURE = 'START_SALE_FAILURE';
export const START_SALE_SUCCESS = 'START_SALE_SUCCESS';
export const START_SALE_TIMEOUT = 'START_SALE_TIMEOUT';

export const PROCESS_SALE_REQUEST = 'PROCESS_SALE_REQUEST';
export const PROCESS_SALE_FAILURE = 'PROCESS_SALE_FAILURE';
export const PROCESS_SALE_SUCCESS = 'PROCESS_SALE_SUCCESS';
export const PROCESS_SALE_TIMEOUT = 'PROCESS_SALE_TIMEOUT';

export const GET_PACKAGES_REQUEST = 'GET_PACKAGES_REQUEST';
export const GET_PACKAGES_FAILURE = 'GET_PACKAGES_FAILURE';
export const GET_PACKAGES_SUCCESS = 'GET_PACKAGES_SUCCESS';
export const GET_PACKAGES_TIMEOUT = 'GET_PACKAGES_TIMEOUT';

export const GET_ADDONS_REQUEST = 'GET_ADDONS_REQUEST';
export const GET_ADDONS_FAILURE = 'GET_ADDONS_FAILURE';
export const GET_ADDONS_SUCCESS = 'GET_ADDONS_SUCCESS';
export const GET_ADDONS_TIMEOUT = 'GET_ADDONS_TIMEOUT';

export const GET_DEALS_REQUEST = 'GET_DEALS_REQUEST';
export const GET_DEALS_FAILURE = 'GET_DEALS_FAILURE';
export const GET_DEALS_SUCCESS = 'GET_DEALS_SUCCESS';
export const GET_DEALS_TIMEOUT = 'GET_DEALS_TIMEOUT';

export const RESERVE_REQUEST = 'RESERVE_REQUEST';
export const RESERVE_FAILURE = 'RESERVE_FAILURE';
export const RESERVE_SUCCESS = 'RESERVE_SUCCESS';
export const RESERVE_TIMEOUT = 'RESERVE_TIMEOUT';

export const CLEAR_RESERVATIONS_REQUEST = 'CLEAR_RESERVATIONS_REQUEST';
export const CLEAR_RESERVATIONS_FAILURE = 'CLEAR_RESERVATIONS_FAILURE';
export const CLEAR_RESERVATIONS_SUCCESS = 'CLEAR_RESERVATIONS_SUCCESS';
export const CLEAR_RESERVATIONS_TIMEOUT = 'CLEAR_RESERVATIONS_TIMEOUT';

export const CLEAR_RESERVATION_REQUEST = 'CLEAR_RESERVATION_REQUEST';
export const CLEAR_RESERVATION_FAILURE = 'CLEAR_RESERVATION_FAILURE';
export const CLEAR_RESERVATION_SUCCESS = 'CLEAR_RESERVATION_SUCCESS';
export const CLEAR_RESERVATION_TIMEOUT = 'CLEAR_RESERVATION_TIMEOUT';

export const VALIDATION_PASSES_LOADING = 'VALIDATION_PASSES_LOADING';
export const VALIDATION_PASSES_FAILURE = 'VALIDATION_PASSES_FAILURE';
export const VALIDATION_PASSES_SUCCESS = 'VALIDATION_PASSES_SUCCESS';
export const REMOVE_MEMBER_BENEFIT = 'REMOVE_MEMBER_BENEFIT';

export const EXPIRE_PACKAGE = 'EXPIRE_PACKAGE';

export const GET_ITEMEXPANDED_REQUEST = 'GET_ITEMEXPANDED_REQUEST';
export const GET_ITEMEXPANDED_FAILURE = 'GET_ITEMEXPANDED_FAILURE';
export const GET_ITEMEXPANDED_SUCCESS = 'GET_ITEMEXPANDED_SUCCESS';
export const GET_ITEMEXPANDED_TIMEOUT = 'GET_ITEMEXPANDED_TIMEOUT';
